import type {EnrichedIssueListItem, IssueLinkedPullRequestSummary} from '../types/list-types'

export type GetIssueReferenceParams = {
  issue: Pick<EnrichedIssueListItem, 'number' | 'repoNameWithOwner'>
  showRepository: boolean
}

export function getIssueReference({issue, showRepository}: GetIssueReferenceParams) {
  if (!showRepository) return `#${issue.number}`
  return `${issue.repoNameWithOwner}#${issue.number}`
}

export function getLinkedPullRequestReference(
  pullRequest: Pick<IssueLinkedPullRequestSummary, 'number' | 'repoNameWithOwner'>,
) {
  if (pullRequest.number == null) return pullRequest.repoNameWithOwner ?? 'Pull request'
  return pullRequest.repoNameWithOwner
    ? `${pullRequest.repoNameWithOwner}#${pullRequest.number}`
    : `#${pullRequest.number}`
}
